import React from 'react';

const DeleteModal = () => {
    return (

        // <img src='../../../../images/delete-icon.svg' alt="deleteicon" />
        <div className='deletemodal-content'>
            <h3>You are about to delete a row data</h3>
            <p>Are you sure you want to delete this data ? This action cannot be undone.</p>
        </div>
        
    );
};

export default DeleteModal;